module.exports = "<app-search-ejecutor></app-search-ejecutor>"